import { mapGetters } from "vuex";
import { store } from "../_store";

export const authComputed = {
  ...mapGetters("authentication", ["currentUser"]),
};

export function getFactorByCode(code) {
  return store.getters["screenFactors/getFactorByCode"](code);
}

export function getDecimalFormatByCode(code) {
  return store.getters["decimalFormattingV1/getDecimalFormatByCode"](code);
}

export function getDecimalFormatByName(name) {
  return store.getters["decimalFormattingV1/getDecimalFormatByName"](name);
}

export function getFriendlyDBDateTimeString(date) {
  return store.getters["dateFormatting/getFriendlyDBDateTimeString"](date);
}

export function getDecimalFormat(name) {
  return store.getters["decimalFormatting/getDecimalFormatByName"](name);
}

export function getGlobalField(fieldName) {
  return store.getters["globalFields/getGlobalField"](fieldName);
}

export function getDefaultUserSettings() {
  return store.getters["defaultUserSettings/getSettings"]();
}

export function getDefaultCustomerSettings() {
  return store.getters["defaultCustomerSettings/getSettings"]();
}

export function getDataContext(key) {
  return store.getters["dataContext/getDataContext"](key);
}


export function getDefaultDateSettings(key) {
  return store.getters["defaultDateSettings/getDateSettings"](key);
}

export function getGCORPInstanceCurrency() {
  return store.getters["defaultUserSettings/getCurrencyCode"]();
}
